/* ============================================================
   CART BUNDLE — synchronized removal for charm-bracelet bundles
   ------------------------------------------------------------
   Defines <bundle-remove-button data-bundle-id="...">. On click,
   collects every line item key sharing that bundle_id and posts
   {updates: {key1:0, key2:0, ...}} to /cart/update.js, then
   refreshes the cart drawer + cart page sections in place.
   ============================================================ */
(function () {
  'use strict';

  class BundleRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();
      const bundleId = this.dataset.bundleId;
      if (!bundleId) return;

      // Collect line keys for every DOM element tagged with this bundle id
      const keys = new Set();
      document
        .querySelectorAll(`[data-bundle-id="${CSS.escape(bundleId)}"]`)
        .forEach(el => {
          const k = el.dataset.lineKey;
          if (k) keys.add(k);
        });
      // Also include any nested member rows (charms/assembly) that carry data-line-key
      document
        .querySelectorAll(`[data-bundle-parent="${CSS.escape(bundleId)}"][data-line-key]`)
        .forEach(el => keys.add(el.dataset.lineKey));

      if (keys.size === 0) return;

      const updates = {};
      keys.forEach(k => { updates[k] = 0; });

      // Loading state
      this.setAttribute('disabled', 'disabled');
      this.classList.add('is-loading');

      fetch(`${window.routes ? window.routes.cart_update_url : '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      })
        .then(res => res.json())
        .then(() => refreshCartSections())
        .catch(err => {
          console.error('[cart-bundle] remove failed', err);
          this.removeAttribute('disabled');
          this.classList.remove('is-loading');
        });
    }
  }

  function refreshCartSections() {
    // Cart drawer
    const drawerEl = document.querySelector('cart-drawer-items');
    if (drawerEl) {
      fetch(`${window.routes ? window.routes.cart_url : '/cart'}?section_id=cart-drawer`)
        .then(res => res.text())
        .then(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          selectors.forEach(sel => {
            const target = document.querySelector(sel);
            const source = parsed.querySelector(sel);
            if (target && source) target.replaceWith(source);
          });
          // Update cart icon bubble
          fetch('/?section_id=cart-icon-bubble')
            .then(r => r.text())
            .then(bubbleHtml => {
              const bubbleEl = document.getElementById('cart-icon-bubble');
              if (bubbleEl) {
                const parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
                const newBubble = parsedBubble.querySelector('.shopify-section');
                if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
              }
            }).catch(() => {});
          // If now empty, mark drawer as empty
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const drawer = document.querySelector('cart-drawer');
              if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
              const innerEmpty = drawer && drawer.querySelector('.drawer__inner');
              if (innerEmpty) innerEmpty.classList.toggle('is-empty', cart.item_count === 0);
            }).catch(() => {});
        })
        .catch(err => console.error('[cart-bundle] drawer refresh failed', err));
    }

    // Cart page
    const cartPageItems = document.querySelector('cart-items');
    if (cartPageItems) {
      fetch(`${window.routes ? window.routes.cart_url : '/cart'}?section_id=main-cart-items`)
        .then(res => res.text())
        .then(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const source = parsed.querySelector('cart-items');
          if (source) cartPageItems.innerHTML = source.innerHTML;
        }).catch(() => {});

      // Footer (totals)
      const footer = document.getElementById('main-cart-footer');
      if (footer) {
        const sectionId = footer.dataset.id || 'main-cart-footer';
        fetch(`${window.routes ? window.routes.cart_url : '/cart'}?section_id=${sectionId}`)
          .then(res => res.text())
          .then(html => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const newJs = parsed.querySelector('.js-contents');
            const target = footer.querySelector('.js-contents');
            if (target && newJs) target.innerHTML = newJs.innerHTML;
          }).catch(() => {});
      }
    }
  }

  if (!customElements.get('bundle-remove-button')) {
    customElements.define('bundle-remove-button', BundleRemoveButton);
  }
})();
